export default {
  de: {
    title: 'Benutzer',
  },
};
